<template>
    <div id="dispute-resolve-invoice-modal-container" v-if="!hidden" :class="{opened: !hidden}">
        <div id="dispute-resolve-invoice-modal">
            <form v-if="type == 'dispute'" method="post" :action="disputeUrl">
                <h1>Disputing Line Item {{ item }}</h1>
                <input type="hidden" name="item_id" :value="id" />
                <p><textarea placeholder="Reasons for disputing." name="note"></textarea></p>
                <div class="actions">
                    <a href="#" @click.prevent="closeModal()">Cancel</a>
                    <input type="submit" value="Log Dispute" />
                </div>
            </form>
            <form v-else method="post" :action="resolveUrl">
                <h1>Resolving Line Item {{ item }}</h1>
                <input type="hidden" name="item_id" :value="id" />
                <p><textarea placeholder="Resolution Outcome." name="note"></textarea></p>
                <div class="actions">
                    <a href="#" @click.prevent="closeModal()">Cancel</a>
                    <input type="submit" value="Resolve Item" />
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['disputeUrl','resolveUrl'],
        data() {
            return {
                hidden: true,
                id: null,
                item: '',
                type:'dispute'
            }
        },
        computed: {},
        methods: {
            closeModal() {
                this.id = null;
                this.item = '';
                this.hidden = true;
                this.type = 'dispute';
            },
            openModal() {
                this.hidden = false;
            }
        },
        mounted() {
            var that = this;

            eventBus.$on('dispute-purchase-invoice-modal-open', function (item, id) {
                that.id = id;
                that.item = item;
                that.type = 'dispute';
                that.openModal();
            });
            eventBus.$on('resolve-purchase-invoice-modal-open', function (item, id) {
                that.id = id;
                that.item = item;
                that.type = 'resolve';
                that.openModal();
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/setup';

    #dispute-resolve-invoice-modal-container {
        display: none;
        &.opened {
            background-color: #fff;
            position: absolute;
            height: 100vh;
            width: 100vw;
            z-index: 10000;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            top:0;
            left:0;
            @include desktop() {
                background-color: rgba(255, 255, 255, 0.8);
            }
        }
    }

    #dispute-resolve-invoice-modal {
        padding: 1em;
        @include grid-column(12);
        @include clearfix();
        @include desktop() {
            background-color: #fff;
            border-radius: $standardBorderRadius;
            box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
            @include grid-column(5);
        }

        div.actions {
            text-align: left;
            margin-top: 30px;
            a, input[type="submit"] {
                padding: 0.7em 0.7em 0.8em;
                text-decoration: none;
                color: #fff;
                border-radius: $standardBorderRadius;
            }
            input[type="submit"]{
                background-color: $green;
            }
            a{
                background-color: #999;
            }
            @include desktop() {
                float: right;
                text-align: right;
                margin-bottom: 0.5em;
            }
        }
    }
</style>
